/* eslint eslint-comments/no-unlimited-disable: off */
/* eslint-disable */
// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
export var RecordType;
(function (RecordType) {
    RecordType[RecordType["EXAMPLE"] = 0] = "EXAMPLE";
    RecordType[RecordType["SAMPLE"] = 1] = "SAMPLE";
    RecordType[RecordType["ANNOTATION"] = 2] = "ANNOTATION";
    RecordType[RecordType["PARAMETER"] = 3] = "PARAMETER";
})(RecordType || (RecordType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVjb3JkLXR5cGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbGliL2dlbmVyYXRlZC9mYnMvcnZhaS9yZWNvcmQtdHlwZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBSyxzREFBc0Q7QUFDdEQsb0JBQW9CO0FBQ3BCLGNBQWM7QUFDbEIscUVBQXFFO0FBRXRFLE1BQU0sQ0FBTixJQUFZLFVBS1g7QUFMRCxXQUFZLFVBQVU7SUFDcEIsaURBQVcsQ0FBQTtJQUNYLCtDQUFVLENBQUE7SUFDVix1REFBYyxDQUFBO0lBQ2QscURBQWEsQ0FBQTtBQUNmLENBQUMsRUFMVyxVQUFVLEtBQVYsVUFBVSxRQUtyQiJ9